import styled from 'styled-components';
import { breakpoints } from '../helpers/breakpoints';
import { Link } from 'gatsby';

export const StyledNavWrapper = styled.header`
  padding: 2rem var(--gutter);
  background: var(--c-white);
  display: flex;
  align-items: center;
  max-width: calc(${breakpoints.mw} - var(--gutter) * 2);
  margin: 0 auto;
  @media screen and (min-width: ${breakpoints.lg}) {
    padding: 4rem var(--gutter);
  }
`;

export const StyledNav = styled.nav`
  margin-left: 2rem;
  @media screen and (min-width: ${breakpoints.md}) {
    margin-left: 3rem;
  }
  @media screen and (min-width: ${breakpoints.lg}) {
    margin-left: 4rem;
  }
`;

export const StyledNavLink = styled(Link)`
  margin-right: 2rem;
  font-size: 1.6rem;
  text-decoration: none;
  color: var(--c-black);
  transition: color 0.3s ease;
  @media (hover: hover) {
    &:hover {
      color: var(--c-red);
    }
  }
  @media screen and (min-width: ${breakpoints.md}) {
    margin-right: 3rem;
  }
  @media screen and (min-width: ${breakpoints.lg}) {
    margin-right: 4rem;
  }
`;
